import React from "react";
import { Spinner } from "react-bootstrap";

type Props = {
	variant?: string;
};

const ButtonSpinner: React.FC<Props> = (props: Props) => {
	const { variant = "light" } = props;

	return (
		<Spinner
			variant={variant}
			animation="border"
			size="sm"
			role="status"
			aria-hidden="false"
			className="fw-normal d-block mx-auto"
		/>
	);
};

export default ButtonSpinner;
